/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { colors } from '../../config/theme';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  continueSurvey: {
    maxWidth: '450px',
    textAlign: 'center'
  },
  continueSurveyContent: {
    color: colors.dustyGray,
    fontWeight: 'bold',
    fontSize: '18px',
    margin: '25px 0'
  }
});

export default useStyles;
